module.exports = require("@splunk/react-ui/JSONTree");